import React from 'react';
import { IQuestionnaireRequestData } from '../types';
import { Divider, Portal } from '@material-ui/core';
import { useStyles } from './styles';
import { QuestionnaireContainer } from './QuestionareContainer';
import { FormAbout } from './FormAbout';
import { PreviewFooter } from './PreviewFooter';
import { InjectedRouter } from 'react-router';

type FormData = Omit<IQuestionnaireRequestData, 'supplierList' | 'inSketch' | 'id'> & { id?: string };

type Props = {
  onClose?: () => void;
  onSave?: () => void;
  router?: InjectedRouter;
  form: FormData;
  enableEdit?: boolean;
};

export const Preview = ({ onClose, form, router, onSave, enableEdit }: Props) => {
  const containerElement = document.getElementById('form-container');
  const { container } = useStyles();

  if (!containerElement) return null;

  return (
    <Portal container={containerElement}>
      <div className={container}>
        <div style={{ padding: '2rem' }}>
          <FormAbout data={form} />
          <Divider />
          <QuestionnaireContainer data={form.questions} disableInput={true} />
        </div>
        <PreviewFooter data={form} router={router} onClose={onClose} onSave={onSave} enableEdit={enableEdit} />
      </div>
    </Portal>
  );
};
